<template>
    <div>
        <div class="flex items-center p-3 px-4 bg-primary-yellow rounded-xl">
            <div class="md:w-6/12 w-full">
                <b class="w-full block mb-2">#{{ summary.rawShipping && summary.rawShipping.shippingReference ?
                    summary.rawShipping.shippingReference : ""}} | Delivered on
                    {{ formatDate(summary.deliveredDate) }}</b>
                <div class="flex_wrapper">
                    <span>Sender:</span>
                    <span>{{ summary.sender && summary.sender.name ? summary.sender.name : 'N/A' }}</span>
                </div>
                <div class="flex_wrapper">
                    <span>Dispatcher:</span>
                    <span>{{ summary.driver && summary.driver.name ? summary.driver.name : 'N/A' }}</span>
                </div>
                <div class="flex_wrapper">
                    <span>Delivered To:</span>
                    <span>{{ summary.receiver && summary.receiver.name ? summary.receiver.name : 'N/A' }}</span>
                </div>
            </div>
            <div class="md:w-6/12 w-full flex justify-end">
                <img src="@/assets/images/onboarding/Logistics-rafiki 1.svg" class="max_img_w" />
            </div>
        </div>

        <h5 class="table_header">
            <img src="./icon/route.svg" />
            Route & Dispatch
        </h5>
        <div class="table_wrapper">
            <table class="table">
                <thead>
                    <tr>
                        <th>#</th>
                        <Th>Shipment ID</Th>
                        <th>Receivers</th>
                        <th>Package Description</th>
                        <th>Delivered To</th>
                    </tr>
                </thead>
                <tbody class="w-full">
                    <tr v-for="(reciever, index) in recievers" :key="index + 'reciever'">
                        <td>{{ index + 1 }}</td>
                        <td>{{ summary.rawShipping && summary.rawShipping.shippingReference ?
                            summary.rawShipping.shippingReference : 'N/A' }}</td>
                        <td>{{ reciever.receiver ? reciever.receiver : 'N/A' }}</td>
                        <td>{{ reciever.description ? reciever.description : 'N/A' }}</td>
                        <td>{{ reciever.deliveredTo ? reciever.deliveredTo : 'N/A' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="btm_cont">
            <button @click="$router.go(-1)">Cancel</button>
            <button v-if="this.summary?.rawShipping?.id" @click="toRating" class="rate_btn">Rate Now</button>
        </div>
        <RatingModal  @success="showSuccessModal = true" :showModal="showRatingModal" @close-modal="showRatingModal = false" />
        <AcknowledgeRating :showModal="showSuccessModal" @close-modal="showSuccessModal = false" />
    </div>
</template>

<script>
import moment from 'moment';
import RatingModal from "@/views/Ondemand/booking/RatingAction.vue"
import AcknowledgeRating from "@/components/Ondemand/Bookings/modals/AcknowledgeRating.vue";

export default {
    name: "delivery-summary",
    components: {
        RatingModal,
        AcknowledgeRating
    },
    data() {
        return {
            summary: {},
            recievers: [],
            showRatingModal: false,
            showSuccessModal: false
        }
    },
    mounted() {
        this.getViewSummary()
    },
    methods: {
        formatDate(date) {
            return moment(date).format("MMM DD, YYYY")
        },
        toRating() {
            if (!this.summary?.rawShipping?.id) {
                this.generateToast("No Dispatcher available to rate", "error");
                return;
            }
            this.$store.dispatch('setRatingsBooking', this.summary?.rawShipping)
            this.showRatingModal = true
        },
        async getViewSummary() {
            try {
                let res = await this.$_getDeliverySummary(this.$route.params?.id);
                this.summary = res?.data?.summary;
                this.recievers = res?.data?.summary?.dispatchTable || []
            } catch (error) {
                //
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    .btm_cont{
        @apply flex items-center justify-between mt-36
    }
.flex_wrapper {
    @apply flex gap-3 items-center w-full mb-1;

    span:nth-of-type(1) {
        @apply text-gray-500
    }
}

.max_img_w {
    @apply max-w-[160px]
}

.table_header {
    @apply text-base font-[600] mt-8 mb-8 pl-2 flex items-center gap-3
}

.table_wrapper {
    @apply w-full mt-5 py-4 px-3 bg-gray-200 overflow-x-auto rounded-xl
}

.table {
    @apply w-full min-w-[800px];
}

.rate_btn {
    @apply py-1.5 px-3 rounded-sm bg-primary-yellow
}
</style>